// context/RefreshContext.jsx
import React, { createContext, useContext, useState, useCallback } from "react";

const RefreshContext = createContext(null);

export const RefreshProvider = ({ children }) => {
  const [refreshData, setRefreshData] = useState(false);

  const handleRefreshData = useCallback(() => {
    setRefreshData((prev) => !prev);
  }, []);

  return (
    <RefreshContext.Provider value={{ refreshData, handleRefreshData }}>
      {children}
    </RefreshContext.Provider>
  );
};

export const useRefresh = () => {
  const ctx = useContext(RefreshContext);
  if (!ctx) throw new Error("useRefresh must be used inside RefreshProvider");
  return ctx;
};
